




































































import { Component, Vue } from 'vue-property-decorator';
import TextManager from '@/script/TextManager';

@Component
export default class EventDetail extends Vue {
  private twitterUrl: string = TextManager.INSTANCE.get('twitter-url')!;
}
